import { apiClient } from './apiClient';
import { normalizeUsersResponse } from './normalizers';

const base = '/api/users';

export const usersService = {
  list: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return apiClient.get(`${base}?${queryParams}`).then(normalizeUsersResponse);
  },
  get: id => apiClient.get(`${base}/${id}`).then(normalizeUsersResponse),
  update: (id, payload) =>
    apiClient.put(`${base}/${id}`, payload).then(normalizeUsersResponse),
  delete: id => apiClient.del(`${base}/${id}`),
  preferencesGet: () => apiClient.get(`${base}/preferences`),
  preferencesUpdate: payload => apiClient.post(`${base}/preferences`, payload),
  getMyFeatureToggles: () => apiClient.get(`${base}/me/feature-toggles`),
};

export default usersService;
